/**
 * Dash0 — enriches RUM telemetry with tenant context.
 *
 * Dash0 is initialized in entry.client.tsx. This module only
 * adds tenant attributes to outgoing signals.
 */

import { addSignalAttribute } from '~/lib/rum';
import type { PluginInitContext } from '~/domain/plugins/types';

export function init(ctx: PluginInitContext): void {
  addSignalAttribute('app.company_id', ctx.companyId);
  addSignalAttribute('app.storefront_id', ctx.storefrontId);
  addSignalAttribute('app.company_name', ctx.companyName);
  addSignalAttribute('app.fqdn', ctx.fqdn);
}
